/**
 * LiFePO4 manufacturer degradation curve (Phase 1: use for all batteries).
 * Used to estimate historical cycles from observed degradation.
 * Authority: docs/implementation/BATTERY_HEALTH_TRACKING.md
 */

/** Cycles → expected degradation % (LiFePO4 typical). */
const LIFEPO4_CURVE: { cycles: number; degradationPercent: number }[] = [
  { cycles: 0, degradationPercent: 0 },
  { cycles: 1000, degradationPercent: 3 },
  { cycles: 2000, degradationPercent: 6 },
  { cycles: 3000, degradationPercent: 10 },
  { cycles: 4000, degradationPercent: 14 },
  { cycles: 5000, degradationPercent: 18 },
  { cycles: 6000, degradationPercent: 20 },
];

export function estimateCyclesFromDegradation(degradationPercent: number): number {
  if (degradationPercent <= 0) return 0;
  for (let i = LIFEPO4_CURVE.length - 1; i >= 0; i--) {
    if (LIFEPO4_CURVE[i].degradationPercent <= degradationPercent) {
      if (i === LIFEPO4_CURVE.length - 1) return LIFEPO4_CURVE[i].cycles;
      const a = LIFEPO4_CURVE[i];
      const b = LIFEPO4_CURVE[i + 1];
      const t = (degradationPercent - a.degradationPercent) / (b.degradationPercent - a.degradationPercent);
      return Math.round(a.cycles + t * (b.cycles - a.cycles));
    }
  }
  return 0;
}

export function estimateDegradationFromCycles(cycles: number): number {
  if (cycles <= 0) return 0;
  for (let i = LIFEPO4_CURVE.length - 1; i >= 0; i--) {
    if (LIFEPO4_CURVE[i].cycles <= cycles) {
      if (i === LIFEPO4_CURVE.length - 1) return LIFEPO4_CURVE[i].degradationPercent;
      const a = LIFEPO4_CURVE[i];
      const b = LIFEPO4_CURVE[i + 1];
      const t = (cycles - a.cycles) / (b.cycles - a.cycles);
      return Math.round((a.degradationPercent + t * (b.degradationPercent - a.degradationPercent)) * 100) / 100;
    }
  }
  return 0;
}

export interface WarrantyThresholds {
  warrantyYears: number;
  warrantyCycles: number;
  warrantyCapacityPercent: number;
}

export function getWarrantyThresholds(plant: {
  warranty_years?: number | null;
  warranty_cycles?: number | null;
  warranty_capacity_percent?: number | null;
}): WarrantyThresholds {
  return {
    warrantyYears: plant.warranty_years ?? 10,
    warrantyCycles: plant.warranty_cycles ?? 6000,
    warrantyCapacityPercent: plant.warranty_capacity_percent ?? 80,
  };
}
